/* ============================================================
   artvision® · Partner werden · Anfrageformular

   Schickt das Formular als JSON an das Laravel-Backend
   (POST /api/partner-requests), das die Anfrage in Directus
   ablegt. Danach ersetzt der Abschluss das Formular und bietet
   den Calendly-Termin an — mit Name und E-Mail vorbelegt.
   ============================================================ */

(function () {
  'use strict';

  var form = document.querySelector('[data-av-pw-form]');
  if (!form) return;

  var root = document.querySelector('[data-av-pw-form-root]');
  var done = document.querySelector('[data-av-pw-done]');
  var errorBox = form.querySelector('[data-av-pw-error]');
  var errorText = form.querySelector('[data-av-pw-error-text]');
  var submit = form.querySelector('[data-av-pw-submit]');
  var submitLabel = form.querySelector('[data-av-pw-submit-label]');
  var labelIdle = submitLabel ? submitLabel.innerHTML : '';

  /* ---------- Prüfen --------------------------------------- */

  function markInvalid(field, invalid) {
    if (invalid) field.setAttribute('aria-invalid', 'true');
    else field.removeAttribute('aria-invalid');
  }

  function checkFields() {
    var first = null;
    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name || field.name === 'fax' || typeof field.checkValidity !== 'function') return;
      var ok = field.checkValidity();
      markInvalid(field, !ok);
      if (!ok && !first) first = field;
    });
    return first;
  }

  form.addEventListener('input', function (event) {
    if (event.target.getAttribute('aria-invalid') === 'true' && event.target.checkValidity()) {
      markInvalid(event.target, false);
    }
  });

  /* ---------- Rückmeldung ---------------------------------- */

  function showError(text) {
    if (!errorBox) return;
    errorText.textContent = text;
    errorBox.hidden = false;
    errorBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function busy(on) {
    submit.disabled = on;
    submit.setAttribute('aria-busy', on ? 'true' : 'false');
    if (submitLabel) submitLabel.innerHTML = on ? 'Wird gesendet …' : labelIdle;
  }

  function calendlyUrl(base, data) {
    try {
      var url = new URL(base);
      var name = [data.first_name, data.last_name].join(' ').trim();
      if (name) url.searchParams.set('name', name);
      if (data.email) url.searchParams.set('email', data.email);
      return url.toString();
    } catch (e) {
      return base;
    }
  }

  function finish(data) {
    var link = done && done.querySelector('[data-av-pw-calendly]');
    if (link) link.href = calendlyUrl(link.getAttribute('href'), data);

    root.hidden = true;
    if (done) {
      done.hidden = false;
      var heading = done.querySelector('[data-av-pw-done-heading]');
      done.scrollIntoView({ block: 'start', behavior: 'smooth' });
      if (heading) heading.focus({ preventScroll: true });
    }
  }

  /* ---------- Absenden ------------------------------------- */

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (errorBox) errorBox.hidden = true;

    var invalid = checkFields();
    if (invalid) {
      showError('Bitte füllen Sie die markierten Felder aus und bestätigen Sie die Datenschutzhinweise.');
      invalid.focus();
      return;
    }

    var endpoint = form.getAttribute('action');
    if (!endpoint) {
      showError('Das Formular ist noch nicht angebunden. Bitte schreiben Sie uns über die Kontaktseite.');
      return;
    }

    var data = {};
    new FormData(form).forEach(function (value, key) {
      data[key] = typeof value === 'string' ? value.trim() : value;
    });
    data.consent = form.elements.consent.checked ? '1' : '';
    data.source = window.location.origin + window.location.pathname;

    busy(true);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          return { status: response.status, body: body };
        });
      })
      .then(function (result) {
        if (result.status === 201 || result.status === 200) {
          finish(data);
          return;
        }

        if (result.status === 422 && result.body && result.body.errors) {
          Object.keys(result.body.errors).forEach(function (key) {
            var field = form.elements[key];
            if (field) markInvalid(field, true);
          });
          showError('Bitte prüfen Sie die markierten Angaben.');
          return;
        }

        if (result.status === 429) {
          showError('Zu viele Anfragen in kurzer Zeit. Bitte versuchen Sie es in einer Minute erneut.');
          return;
        }

        showError('Bitte versuchen Sie es später erneut oder schreiben Sie uns über die Kontaktseite.');
      })
      .catch(function () {
        showError('Keine Verbindung. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.');
      })
      .then(function () {
        busy(false);
      });
  });
})();
